
import { InboxOutlined } from '@ant-design/icons';
import type { UploadFile, UploadProps } from 'antd';
import { message, Upload } from 'antd';

const { Dragger } = Upload;

interface UploadCsvDraggerProps {
  fileList: UploadFile[];
  setFileList: (fileList: UploadFile[]) => void;
}

export default function UploadCsvDragger(props: UploadCsvDraggerProps) {
  const internalProps: UploadProps = {
    name: 'file',
    multiple: false,
    onRemove: (file) => {
      props.setFileList([]);
    },
    beforeUpload: (file) => {
      const isValidFile = file.type === "text/csv" || 
                         file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || 
                         file.type === "application/vnd.ms-excel";
      
      if (isValidFile) {
        props.setFileList([file]);
      } else {
        message.error(`${file.name} is not a valid CSV or Excel file`);
      }
      return false;
    },
    fileList: props.fileList,
  };

  return (
    <Dragger {...internalProps}>
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">Click or drag Physical Sim inventory file here</p>
      <p className="ant-upload-hint">
        Make sure the file is in the same template as provided
        <br/>Accepts CSV, XLS, and XLSX files.
      </p>
    </Dragger>
  );
}